// PO1-3481: "Coletar até" e "Entregar até" (data e hora) da cotação e do leilão.
// O input é datetime-local (hora do navegador); a API recebe e devolve ISO.

const pad2 = (n) => String(n).padStart(2, "0");
const MS_DIA = 24 * 60 * 60 * 1000;

// ISO (ou Date) → "YYYY-MM-DDTHH:mm" no fuso do navegador, para o input.
export function paraInputLocal(v) {
  if (!v) return "";
  const d = new Date(v);
  if (!Number.isFinite(d.getTime())) return "";
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

// Valor do input → ISO; vazio → "" (a API entende "" como sem limite).
export function deInputLocal(v) {
  if (!v) return "";
  const d = new Date(v);
  return Number.isFinite(d.getTime()) ? d.toISOString() : "";
}

// "YYYY-MM-DD" local do valor do input (o dia da coleta no leilão).
export function diaDoInput(v) {
  return v ? String(v).slice(0, 10) : "";
}

// Mínimo do input: agora, no formato do datetime-local.
export function agoraInputLocal(agora) {
  return paraInputLocal(agora || new Date());
}

// Erros por campo, no mesmo texto do backend.
export function validarLimites({ coletarAte, entregarAte, agora }) {
  const erros = {};
  const t0 = (agora || new Date()).getTime();
  const c = coletarAte ? new Date(coletarAte).getTime() : null;
  const e = entregarAte ? new Date(entregarAte).getTime() : null;
  if (c !== null && !Number.isFinite(c)) erros.coletarAte = "Data e hora de coleta inválidas.";
  else if (c !== null && c <= t0) erros.coletarAte = "O horário limite de coleta já passou.";
  if (e !== null && !Number.isFinite(e)) erros.entregarAte = "Data e hora de entrega inválidas.";
  else if (e !== null && e <= t0) erros.entregarAte = "O horário limite de entrega já passou.";
  else if (e !== null && c !== null && Number.isFinite(c) && e <= c) erros.entregarAte = "A entrega precisa ser depois da coleta.";
  return erros;
}

// Urgente = limite de coleta nas próximas 24 horas (mesma regra do backend).
export function ehUrgente(coletarAte, agora) {
  if (!coletarAte) return false;
  const c = new Date(coletarAte).getTime();
  if (!Number.isFinite(c)) return false;
  return c - (agora || new Date()).getTime() <= MS_DIA;
}

// "17/10 16:00" (com o ano quando não é o ano corrente).
export function fmtLimite(v, agora) {
  if (!v) return "—";
  const d = new Date(v);
  if (!Number.isFinite(d.getTime())) return "—";
  const ano = (agora || new Date()).getFullYear() === d.getFullYear() ? "" : `/${d.getFullYear()}`;
  return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}${ano} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
